import { createContext, useContext } from "react";

const GeneralContext = createContext({});

export const useGeneralState = () => useContext(GeneralContext);

export default GeneralContext;
